export default {
    nav: {
      home: '首页',
      service: '产品服务',
      case: '典型案例',
      partner: '合作伙伴',
      contact: '联系我们',

    },
    home: {
        bannerTitle: '会展/大型活动/演出舞台',
        bannerSubTitle: '复杂临建结构工程咨询',
        bannerInfo: '3位全职同济土木持证国家一级结构工程师/土木工程师',
        bannerSubInfo: '11年国内外会展临时结构工程经验',
        bannerDetail: '上海佰里是国内少有的专注于会展/大型活动/演出舞台等领域的临建结构工程咨询公司。公司创始团队拥有来自同济大学土木工程学院的全日制本硕博、本硕、本科各1名。全职中国国家一级注册结构工程师2名，中国国家注册土木工程师1名。',
        bannerSubDetail: '创始团队拥有11年的从早期方案咨询、图纸设计、场地报批，到生产制作、现场安装安全监管全流程的服务经验。与国内外众多顶级的活动公司、公关公司、创意设计公司、展览公司、AV公司、结构工厂、各地展馆及商场，均有长期稳定合作。',
        xu: {
            name: '徐意智',
            info: '同济大学/博士',
            subInfo: '国家注册土木工程师',
            detail1: '本科到硕士博士，同济大学12年土木工程专业学科背景。',
            detail2: '11年上海/北京国际车展和各类大型活动定制钢结构设计、制作和现场一线搭建经验。',
            detail3: '9年上海/北京/成都/广州国际车展和各类演出及商业活动铝合金truss结构研发设计、生产制作及现场工程安装经验。',
            detail4: '5年自营结构工厂（上海鹏观）生产管理经验，对国内外上下游产业链/结构设计技术/工厂生产工艺/现场安装技术/国内主要场馆及活动场地均有深入了解及研究。'
        },
        chou: {
            name: '周成龙',
            info: '同济大学/学士',
            subInfo: '国家一级注册结构工程师',
            detail1: '毕业于同济大学土木工程专业，现任上海鹏观首席工程师。',
            detail2: '自2019年以来，负责上海/北京/广州/成都车展、上海国际博览会、2019广州大众品牌之夜等活动的前期结构设计和现场安全顾问工作。',
            detail3: '擅长各类室内、外广告活动中展台结构设计、计算及场地安全复核，如2022年海口日月广场免税店阿玛尼展台、三亚艾迪逊酒店迪奥水上平台以及旋转星型装饰结构。',
            detail4: '担任百余场会展展台搭建的现场结构安全顾问。',
            detail5: '熟悉常见结构形式如混凝土框架、混凝土剪力墙、混凝土核心筒框架、钢结构框架、混凝土核心筒钢框架、门式钢结构，为现有建筑物提供结构咨询服务。',
        },
        lee: {
            name: '李璐',
            info: '同济大学/硕士',
            subInfo: '国家一级注册结构工程师',
            detail1: '同济大学7年结构工程专业背景，本科毕业于建筑工程系，研究生主修钢结构理论与施工技术方向。',
            detail2: '为上海/广州车展多个展台提供结构咨询服务，如2023上海车展宝马展位重型truss计算分析，保时捷展位truss施工过程计算及设计验算。',
            detail3: '为大型复杂户外、室内活动提供结构的方案设计、方案优化及计算分析服务。',
            detail4: '擅长复杂空间结构建模、设计计算、抗风及整体稳定性分析。',
            detail5: '10余年结构咨询经验，精通各类传统结构形式的方案设计、计算分析、监测及结构评估，如框架、框剪、框筒结构，空间桁架、网壳结构，大跨度空间网格结构等。',
        }
    },
    service: {
        list: [
            {
                title: '复杂结构方案咨询',
                content: '结构概念设计，结构可行性论证，项目技术投标咨询服务。',
                case: '案例：遇见新大众广州发布会（2019） 、三亚艾迪逊酒店迪奥水上快闪店（2022）、英雄联盟全球总决赛S10（2020）、VIVO户外大事件（2023）、成都远洋太古里秋季和冬季装饰（2022）。',
                images: [
                    'service_1-1.png',
                    'service_1-2.png',
                    'service_1-3.png',
                    'service_1-4.png',
                ]
            },
            {
                title: '结构设计安全审核',
                content: '结构概念设计，结构可行性论证，项目技术投标咨询服务结构详细设计、施工图设计、结构计算报告及安全建议，国家甲级设计院、国家一级注册结构工程师盖章复核。',
                case: '案例：2019年上海国际车展6个展位（林肯、捷豹路虎、英菲尼迪、日产等）、2020年北京国际车展8个展位（林肯、福特、保时捷、玛莎拉蒂等）、2021年上海国际车展9个展位（保时捷、福特、本田、林肯、捷豹路虎、捷尼赛思等）、2021年上海进博会7个展位（DOW、赛默飞、雪花秀、上海馆等）、2023年上海车展18个展位（BMW、MINI、RR、保时捷、奥迪、捷豹路虎、玛莎拉蒂、仰望、POLESTAR、兰博基尼、日产、现代等）、各B级C级车展。',
                images: [
                    'service_2-1.png',
                    'service_2-2.png',
                    'service_2-3.png',
                    'service_2-4.png',
                ]
            },
            {
                title: '现场结构安全监理',
                content: '国家一级注册结构工程师、监理工程师全程参与工厂制作、试搭建、现场结构搭建安装，从理论设计到实际过程，切实为结构安全提供多一层的保障。',
                case: '案例：上汽大众深圳车展展台（2020）、上汽大众成都车展展台（2020）、上汽大众上海车展展台（2021）、上海进博会2号馆3号馆全部展台（2021、2022）。',
                images: [
                    'service_3-1.png',
                    'service_3-2.png',
                    'service_3-3.png',
                    'service_3-4.png',
                ]
            },
            {
                title: '结构监测、测试及舞台检测服务',
                content: '采用现代化监测元器件、仪器设备对结构的实际状态进行监测、测试，并可与第三方合作，提供舞台结构设备的检测服务。',
                case: '案例：花海美妆嘉年华演唱会舞台结构（2021）、成都远洋太古里SOKEL冬季装饰（2021）、TF上海新天地展台（2021）、Cindy Chao上海珠宝展（2021）。',
                images: [
                    'service_4-1.png',
                    'service_4-2.png',
                    'service_4-3.png',
                    'service_4-4.png',
                ]
            },
            {
                title: '场地报批服务',
                content: '除结构计算书、结构计算报告、结构图纸之外，还可为客户提供消电检、整体安全验收等与场地报批相关的一条龙代理技术服务。',
                case: '案例：蚂蚁金服外滩大会展台（2020）',
                images: [
                    'service_5-1.png',
                    'service_5-2.png',
                    'service_5-3.png',
                    'service_5-4.png',
                ]
            }
        ]
    },
    case: {
        more: '查看更多',
        list: [
            {
                key: '1',
                title: '2022 Dior三亚艾迪逊酒店泳池POP-UP',
                desc: '用一周的时间，在三亚海边五星酒店水深两米的不抽水泳池里“填海”造一个圆形小岛式的钢结构POP-UP，一条漂浮在水上的飘带及海上的明珠。',
                content: `结构抗台风设计、
                泳池基底保护设计、
                结构件拆分及拼装设计、
                结构构件搬运、
                水面定位放样、
                水下水泥柱墩搬运及安装、
                水上钢结构吊装安装、
                水上临时吊装龙门架设…`,
                image: 'case_1.jpeg',
                detail: [
                    {
                        type: 'text',
                        content: `这个项目是2022年5月份在三亚艾迪逊酒店泳池里搭建的一个直径10m，高约3.3m的一个圆形的快闪店。所有的环形步道（直径18m）、弧形连桥、圆形房子均是新建在水深2m且不抽水的泳池之上，泳池距离海边不足200m，泳池的水系与海水相连通，有很强的腐蚀性，所以这套结构除了没有海浪侵袭之外，其他方面很接近于海上建筑。`,
                    },
                    {
                        type: 'image',
                        content: 'case_1_1.png',
                    },
                    {
                        type: 'text',
                        content: `为保护泳池池底，酒店方要求新搭建的建筑对池底的压力不能超过10kN/m2。为抵御13级台风，结构需要有足够的配重；而为了保护泳池池底，结构的自重又不能过重。为此结构工程师需要在结构抵御台风与保护泳池池底之间作出精细的平衡。
                        此外，由于泳池距离酒店的卸货通道有近200米，几乎所有的搬运车辆、施工机械、吊装设备都无法靠近泳池，水上不允许有焊接作业，所有的结构构件及基础构件均需要靠人力在水上进行拼接，且水池是不抽水作业的。而该项目给到现场的运输搭建时间仅仅为7个白天。为此，结构工程师需要综合考虑结构总体安全、结构构件搬运、结构构件水上定位、水下基础拼装组装、水上钢梁吊装拼装、临时施工步道等因素，帮助客户克服现场存在的诸多困难，在7天内将创意落地变成现实。
                        水上的测量和定位是第一步，需要避开恶劣风浪天气，保证应有的精度，否则为后面水上环形钢梁的拼接带来困难。`
                    },
                    {
                        type: 'image',
                        content: 'case_1_2.jpeg',
                        desc: '',
                    },
                    {
                        type: 'image',
                        content: 'case_1_3.png',
                        desc: '水上测量及定位'
                    },
                    {
                        type: 'text',
                        content: '为减小陆地人工搬运以及水上搬运的难度，我们将结构基础拆分成了198块定制的梯形混凝土块，使得每块的重量不超过260kg，同时在水泥块上设计了搬运和吊装预埋件，同时钢梁也需设计成单件重量不超过200kg的构件。'
                    },
                    {
                        type: 'image',
                        content: 'case_1_4.png',
                    },
                    {
                        type: 'image',
                        content: 'case_1_5.png',
                    },
                    {
                        type: 'text',
                        content: '为减小陆地人工搬运以及水上搬运的难度，我们将结构基础拆分成了198块定制的梯形混凝土块，使得每块的重量不超过260kg，同时在水泥块上设计了搬运和吊装预埋件，同时钢梁也需设计成单件重量不超过200kg的构件。'
                    },
                    {
                        type: 'image',
                        content: 'case_1_6.png',
                    },
                    {
                        type: 'text',
                        content: '为了方便水上搬运、吊装和施工，还专门设计了一套临时施工平台以及truss架龙门结构，为基础水泥块、钢结构、房间大玻璃的吊装提供条件。'
                    },
                    {
                        type: 'image',
                        content: 'case_1_7.png',
                    },
                    {
                        type: 'image',
                        content: 'case_1_8.jpeg',
                    },
                    {
                        type: 'text',
                        content: '上海佰里参与了上述全过程的结构方案设计、施工方案设计、现场结构搭建安全监理等工作。'
                    },
                ]
            },
            {
                key: '2',
                title: 'Dior 三亚水上星星',
                desc: '该项目为艾迪逊酒店泳池内的快闪店的接续项目，将水上快闪店部分拆除，留下水下基础平台，在上面新建一个可转动的星型装饰。',
                content: '星型装饰为一个单柱结构，需要抵抗13级台风，以及转动工况下的稳定性；新建结构需要建立在原水下基础平台之上，与原结构如何连接',
                image: 'case_2.jpeg',
                detail: [
                    {
                        type: 'text',
                        content: '此项目为迪奥水上快闪店的接续项目，由于快闪店设计的时候已经充分考虑了接续项目的可能性，因此原水下基础平台又被利用了起来。星型装饰主结构为一个单立柱，迎风面为集中在顶端，设防风级为13级台风。通过多次试算，我们选择了底部直径377mm，壁厚6mm圆管，上部减小为直径219mm，壁厚6mm，粗细立柱连接部分采用法兰盘螺栓连接，保证了刚性连接的需求。中部焊接铁板圆球，外圈焊接加强铁板，连接菱形尖角。内部结构图纸见下图：',
                    },
                    {
                        type: 'image',
                        content: 'case_2_1.png'
                    },
                    {
                        type: 'text',
                        content: '立柱底部需要保证刚性连接，我们采用了大铁板底座1.6x1.6x0.02m，大铁板的自重可增强底座稳定性的同时，也增加了与地台铁架的接触面积，设置了共16颗高强螺栓固定，使底座牢牢固定在基础地台之上。配合底座旋转需求，电机的设置，我们设计了两套铁架，上下叠置，下部铁架与原水下基础平台连接，上部铁架地台铁架。底部图纸如下图：'
                    },
                    {
                        type: 'image',
                        content: 'case_2_2.png'
                    },
                    {
                        type: 'text',
                        content: '外圈上人平台的设计，将承重点全部落在了原水下平台基础柱墩点上，很好的利用了原基础，实现了水上结构的转换。基础平面如下图所示：',
                    },
                    {
                        type: 'image',
                        content: 'case_2_3.png',
                    }
                ]
            },
            {
                key: '3',
                title: '成都远洋太古里冬季装饰',
                desc: '该项目位于成都远洋太古里广场上。成都冬日少雪，本项目造型为一个波浪起伏的顶面，上面是积雪造型，雪顶下部设置爆炸球雪球装饰，效果迷人，成为成都红极一时的热门打卡点。设计效果图图（上）和拍摄实景图（下）',
                content: '我们负责本项目中的结构方案定案，结构图纸的设计，结构计算，以及后续施工建造过程中的技术咨询。该项目难点如下：1、顶棚为异形，设计，制作难度大；2、成都10年一遇基本风压0.25kPa，相当于8~9级风，顶棚为四面敞开体型，风荷载效应大；3、造型要求，本结构为立柱支承顶棚铁架，相当于传统土建的无梁楼板，柱板节点设计难度大，楼板厚度需兼顾造型需求不能太厚，同时满足结构承载力需求。',
                image: ['case_3.1.png', 'case_3.2.jpeg'],
                detail: [
                    {
                        type: 'text',
                        content: `项目位于成都太古里商场，装饰效果非常不错。但对结构设计来说是个挑战。
                        异形顶棚的设计，选定了厚度400mm的双层铁架，沿波浪造型做异形面。反复调整柱位，达到柱位最少的目的。柱间无梁，为增强结构的抗水平风力，在柱底设置了100mm高工字钢地梁，将各个立柱连接为一个整体。
                        针对造型复杂的问题，我们先运用三维软件，根据三维图里的表皮样条线，一块块描出三维线条，该结构的三维线条图如下：
                        `,
                    },
                    {
                        type: 'image',
                        content: 'case_3_1.png'
                    },
                    {
                        type: 'text',
                        content: '将该线条文件导入结构计算软件，建立了如下图的结构验算模型：'
                    },
                    {
                        type: 'image',
                        content: 'case_3_2.png',
                    },
                    {
                        type: 'text',
                        content: `针对风荷载敏感的问题，按照《建筑结构荷载规范》，同时考虑水平向风压和顶棚风吸，确保风载不漏以及准确。
                        柱顶节点进行了两种节点的比选，一个是参照混凝土结构无梁楼板的设计，柱顶设大铁板（柱帽），铁架下弦杆与铁板螺栓对穿，一个是铁架高度范围内设圆套筒，套在立柱上，并用高强螺栓对穿。最终选定了第二种节点做法，实拍图片如下：
                        `
                    },
                    {
                        type: 'image',
                        content: 'case_3_3.png',
                    },
                    {
                        type: 'text',
                        content: '该节点的优势是：1、柱顶节点刚度更强；2、施工更方便；3、避免了柱顶铁架的应力集中。过程中我们不断优化，找到了结构设计合理与造型需求的结合点，完美实现了效果设计意图。'
                    }
                ]
            },
            {
                key: '4',
                title: '遇见新大众',
                desc: '该发布会占地约5000平，地点位于广州塔下的广州媒体港。位于广州塔下，人流如织，配合广州塔打出活动广告的效果，品牌方非常满意。',
                content: '该结构为刚刚竣工，本发布会位于框架顶板上。顶板原设计方，只提供出消防车道3.5t/m2，消防车道以外500kg/m2的粗略使用要求。本活动为第一次使用此结构顶板，活动需要搭建的篷房，单柱柱底最大7.5t，能否安全承重呢？施工过程中，需要在消防车道以外走行最大自重13t的吊车， 能否安全承重呢？',
                image: 'case_4.jpeg',
                detail: [
                    {
                        type: 'text',
                        content: `顶板承重的问题，首先需要了解原顶板的设计。我们首先配合主办方找到广州电视台的基建部门，要到了一套完成的建筑和结构两个专业的设计图纸。同时，我们搜集了活动需要使用的各个使用功能以及搭建物的重量，请各专业分包商提供出了如下重量分布表：`,
                    },
                    {
                        type: 'image',
                        content: 'case_4_1.png',
                    },
                    {
                        type: 'image',
                        content: 'case_4_2.png',
                    },
                    {
                        type: 'text',
                        content: `为保证活动顺利以及结构的安全，我们制定了重量使用的如下原则：保证必须的重量，减去不必要的重量，预留尽量多的重量。
                        例如我们发现，篷房的立柱单点重量之所以非常大，除了篷房自重以及天花内灯光truss及灯光设备的重量外，有3t的重量来自于对篷房柱脚的水泥块配重。我们检查了该篷房的计算书，该配重的风载设防标准为上海地区50年一遇基本风压0.55kPa，而广州地区10年一遇基本风压仅为0.3kPa（活动持续时间10天，按临时结构考虑），不需要如此多的配重。尽管我们对此项进行了专业的分析及计算，但篷房分包方（某外资）坚持需要3t的配重。我们需要重新寻找方法，替代这个3t的重量。
                        我们对图纸进行了深度学习，了解到该结构顶板的详细做法如下表：
                        `,
                    },
                    {
                        type: 'image',
                        content: 'case_4_3.png',
                    },
                    {
                        type: 'text',
                        content: `我们想到可以在柱底用抗拉锚栓打入建筑面层，只要控制锚栓深度不大于150mm，就不会破坏原顶板建筑防水层。在施工前，篷房分包方按照我们的方案进行了现场锚栓抗拔试验，18处柱脚中，只有3处柱脚锚栓不满足3t的抗拔要求（柱脚锚板被拉坏，面层破坏，分析原因为该处面层内积水，C20的混凝土强度不达标），该方案得以最终实施，减少了不必要的重量。
                        针对施工过程中需要走行自重13t的吊车问题，我们通过等效均布荷载的方法，理论验证了吊车走行的等效均布荷载小于500kg/m2的限值要求。同时在现场利用灭火器标注出顶板上各个楼下混凝土立柱的位置，限值吊车跨柱走行，使得重量分担在两个不同的柱跨内，进一步提升了我们的施工安全系数。
                        活动设施搭建期间，我们建立了顶板安全巡视制度，每日巡查顶板下楼板情况，形成了每日报告。
                        `,
                    },
                    {
                        type: 'image',
                        content: 'case_4_4.jpeg',
                    },
                    {
                        type: 'text',
                        content: `我们挑选了几个特定进度节点，对柱跨跨中进行沉降观测，并形成了水准测量报告。`,
                    },
                    {
                        type: 'image',
                        content: 'case_4_5.png',
                    },
                    {
                        type: 'text',
                        content: `以上两项工作，均证实了楼板正在安全承重。
                        后期，在活动进行期间，以及结束后撤场期间，应主办要求，我们均负责了场地的安全巡视、监测工作。
                        `,
                    },
                ]
            },
        ]
    },
    partner: {

    },
    contact: {
        title: '业务联系：',
        email: '邮箱：',
        wechat: '微信：',
        redbook: '小红书：',
        tiktok: '抖音：',
        phone: '电话：',
        address: '地址：'
    }
  }
